'use client';

import React from 'react';
import * as SubframeUtils from '../utils';

interface PageHeader_MainRootProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  breadcrumbs?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  innerPadding?: boolean;
  className?: string;
}

const PageHeader_MainRoot = React.forwardRef<HTMLDivElement, PageHeader_MainRootProps>(
  function PageHeader_MainRoot(
    { breadcrumbs, title, subtitle, actions, innerPadding = false, className, ...otherProps },
    ref,
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          'flex w-full flex-col items-start gap-4 border-b border-solid border-neutral-100 pb-6',
          { 'px-6': innerPadding },
          className,
        )}
        ref={ref}
        {...otherProps}
      >
        {breadcrumbs ? <div className="flex items-center gap-2">{breadcrumbs}</div> : null}

        <div className="flex w-full flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <div className="flex flex-col items-start gap-1">
            <h1 className="text-heading-1 font-heading-1 text-default-font">{title}</h1>
            {subtitle ? (
              <span className="text-body font-body text-subtext-color">{subtitle}</span>
            ) : null}
          </div>

          {actions ? <div className="flex items-center gap-3">{actions}</div> : null}
        </div>
      </div>
    );
  },
);

export const PageHeader_Main = PageHeader_MainRoot;
